import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Recipe } from "../../types/shopify";
import { ReduxState } from "../../types/redux";
import "./styles/BlogCard.css";

interface Props {
  blogData?: any; // Using any as a placeholder, ideally this would be a proper BlogData type
  shopifyBlog?: Recipe; // Still using Recipe type from Shopify since the data structure is the same
  isShopifyBlog?: boolean;
  currentBlogHandle?: string; // The current blog handle from the parent component
}

interface State {
  imageLoadHasFailed: boolean;
}

class BlogCardMobile extends Component<Props, State> {
  state = {
    imageLoadHasFailed: false,
  };

  render() {
    const { blogData, shopifyBlog, isShopifyBlog } = this.props;
    
    // If no data is provided, return null
    if (!blogData && !shopifyBlog) {
      return null;
    }
    return (
      <div className="blog-card-mobile">
        <div
          id={isShopifyBlog && shopifyBlog ? shopifyBlog.id : blogData?.id?.toString() || ''}
          className="blog-card-mobile-container card u-background--white u-br--small u-relative"
        >
              {/* Top - Image */}
              <div>
                {(isShopifyBlog && shopifyBlog && shopifyBlog.image) || (blogData && blogData.imagePath) ? (
                  <img
                    id="item-image"
                    className="blog-image-mobile"
                    src={isShopifyBlog && shopifyBlog && shopifyBlog.image ? shopifyBlog.image.url : blogData?.imagePath}
                    alt={isShopifyBlog && shopifyBlog ? shopifyBlog.title : blogData?.title}
                    onError={() => {
                      this.setState({ imageLoadHasFailed: true });
                    }}
                  />
                ) : (
                  <div className="blog-image-placeholder-mobile u-background--grey u-w-all u-main-font--vsmall u-semi-bold u-text-center">
                    416X255
                  </div>
                )}
              </div>
              {/* Bottom - Content */}
              <div className="blog-content-mobile">
                {/* Title and content */}
                <div>
                  <Link 
                    to={isShopifyBlog && shopifyBlog 
                      ? `/browse/blogs/${shopifyBlog.handle}` 
                      : `/browse/blogs/${blogData?.id}`}
                    style={{ textDecoration: 'none', color: '#333' }}
                    onClick={() => {
                      // Store the correct blog handle for this article in sessionStorage
                      const blogHandle = shopifyBlog?.blogHandle || this.props.currentBlogHandle;
                      if (blogHandle) {
                        console.log(`Storing blog handle in sessionStorage: ${blogHandle}`);
                        sessionStorage.setItem('current_blog_handle', blogHandle);
                      }
                    }}
                  >
                    <h3 className="blog-title-mobile">
                      {isShopifyBlog && shopifyBlog ? shopifyBlog.title : blogData?.title}
                    </h3>
                  </Link>
                  
                  {isShopifyBlog && shopifyBlog ? (
                    <>
                      <div className="blog-meta-mobile">
                        {isShopifyBlog && shopifyBlog.tags && shopifyBlog.tags.length > 0 ? shopifyBlog.tags[0] : 'Blog'} - {new Date(shopifyBlog.publishedAt).toLocaleDateString()}
                      </div>
                      <div className="blog-excerpt-mobile">
                        {shopifyBlog.excerpt}
                      </div>
                    </>
                  ) : (
                    <div className="u-flex">
                      <div className="u-w-half">
                        <div className="u-main-font--vsmall u-bold">
                          PREP TIME
                        </div>
                        <div className="u-main-font--vsmall">
                          {blogData?.prepTimeMinutes}
                        </div>
                      </div>
                      <div className="u-w-half">
                        <div className="u-main-font--vsmall u-bold">
                          COOK TIME
                        </div>
                        <div className="u-main-font--vsmall">
                          {blogData?.cookTimeMinutes}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                
                {/* Read More link */}
                <div className="blog-footer-mobile">
                  <Link
                    className="read-more-link-mobile"
                    to={isShopifyBlog && shopifyBlog 
                      ? `/browse/blogs/${shopifyBlog.handle}` 
                      : `/browse/blogs/${blogData?.id}`}
                    onClick={() => {
                      // Store the correct blog handle for this article in sessionStorage
                      const blogHandle = shopifyBlog?.blogHandle || this.props.currentBlogHandle;
                      if (blogHandle) {
                        console.log(`Storing blog handle in sessionStorage: ${blogHandle}`);
                        sessionStorage.setItem('current_blog_handle', blogHandle);
                      }
                    }}
                  >
                    <span className="read-more-text-mobile">Read More</span>
                    <span className="read-more-arrow-mobile">&rarr;</span>
                  </Link>
                </div>
              </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  blogs: state.recipes, // Still using recipes state since that's where the data comes from
  shopifyBlogs: state.recipes.shopifyRecipes,
});

export default connect(mapStateToProps, null)(BlogCardMobile);
